export enum ETypeOfBranchServices {
    All =0,
    DeliveryOnly =1,
    PickupOnly =2,
    DeliveryAndPickup = 3,
}